import { render, staticRenderFns } from "./prepaidsettlevoid.vue?vue&type=template&id=7a0c24c6&"
import script from "./prepaidsettlevoid.vue?vue&type=script&lang=js&"
export * from "./prepaidsettlevoid.vue?vue&type=script&lang=js&"
import style0 from "./prepaidsettlevoid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports